import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  .wrapper-outer-div {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    #block1 {
      flex: 1;
      div {
        display: flex;
        align-items: center;
        padding-left: 10px;
      }
      span {
        display: flex !important;
        gap: 8px;
        padding-left: 6px;
      }
    }
    #block2 {
      flex: 1;
      span {
        display: flex !important;
      }
    }
    #block3 {
      flex: 1;
      span {
        display: flex !important;
        padding-left: 2em;
      }
    }
    #block4 {
      flex: 1;
      span {
        display: flex !important;
      }
    }
    #block5 {
      span {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-right: 0.5em;
      }
    }
  }
`;
const SkeletonFormListingHeader: React.FC = () => {
  return (
    <Wrapper className="skeleton-form-listing">
      <div className="wrapper-outer-div">
        <div id="block1">
          <div>
            <span>
              <Skeleton.Button
                style={{ width: '19px', height: '19px', display: 'flex', alignItems: 'center', marginRight: '4px', borderRadius: '5px' }}
                active
                size={'small'}
                shape={'square'}
                block={true}
              />
            </span>
            <span style={{ display: 'flex', flexDirection: 'column' }}>
              <Skeleton.Button style={{ width: '60px', height: '18px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
            </span>
          </div>
        </div>
        <div id="block2">
          <span>
            <Skeleton.Button style={{ width: '50px', height: '16px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
        <div id="block3">
          <span>
            <Skeleton.Button style={{ width: '100px', height: '16px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
        <div id="block4">
          <span>
            <Skeleton.Button style={{ width: '100px', height: '16px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
        <div id="block5">
          <span>
            <span style={{ width: '6px', height: '20px', borderRadius: '8px' }}></span>
          </span>
        </div>
      </div>
    </Wrapper>
  );
};

export default SkeletonFormListingHeader;
